import { observer } from 'mobx-react-lite';
import { useWindowDimensions, View, ViewStyle } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { TestIDs } from 'src/constants/testIDs.constants';
import { bottomSheetTestID } from 'src/helpers/testIDs.helper';
import { brand } from 'src/theme/colors';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { style } from './BottomSheetDiscount.style';
import { DiscountInfo } from '../discount-info/DiscountInfo';
import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';
import { IconGhostBlackButton } from '../icon-buttons/icon-ghost-black-button/IconGhostBlackButton';
import { BUTTON_SIZES } from '../buttons/button/Button.constants';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { Icon } from '@photosi/rn-components/icon/Icon';

export const BottomSheetDiscount = observer(({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    bottomSheet: { closeBottomSheet, bottomSheetData, suggestedFormatCard },
  } = useStore();

  const discounts: DiscountScale[] = bottomSheetData;

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.container} accessibilityViewIsModal={true}>
        <View style={style.header}>
          <View style={[style.leftElement, { gap: 4, flex: 1 }]}>
            <Icon name={ICON_NAMES.DiscountSimpleV3} color={brand.main.orange} width={16} height={16} filled />
            <View style={style.leftTextContainer}>
              <TextLato style={style.leftTextTitleMobile}>{i18n.t('discounts-table:prints-title')}</TextLato>
            </View>
            <IconGhostBlackButton
              size={BUTTON_SIZES.SMALL}
              testID={bottomSheetTestID(TestIDs.CLOSE)}
              focusId={bottomSheetTestID(TestIDs.CLOSE)}
              focusOrder={0}
              focusGroup={FocusGroups.BOTTOM_SHEET}
              iconName={ICON_NAMES.Close}
              accessible={true}
              accessibilityLabel={i18n.t('actions:close_x', { x: '' })}
              accessibilityRole="button"
              onPress={async () => closeBottomSheet()}
            />
          </View>
        </View>
        <View style={[style.leftElement, { gap: 4, flex: 1, paddingHorizontal: 16 }]}>
          <View style={style.leftTextContainer}>
            <TextLato style={style.leftTextSubTitleMobile}>
              {i18n.t('discounts-table:prints-description-mobile', { format: i18n.t(suggestedFormatCard?.title) })}
            </TextLato>
          </View>
        </View>
        <View style={style.body}>{discounts?.length > 1 && <DiscountInfo discount={discounts} />}</View>
      </View>
    </BottomSheetScrollView>
  );
});
